
<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :status="'HISTORY'"
                :title="'예약 신청내역'"
            />
            <div class="content">
                <div class="content-table ">
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            예약자명
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.visitorName }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            전화번호
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.visitorPhone }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            예약구분
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.visitorCategory === "PARENT" ? "학부모" : "외부인" }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            예약상태
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ getStatusMessage(reservation.status) }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            방문 선생님
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.reservedTeacherName }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item" v-if="reservation.visitorCategory === 'PARENT'">
                        <div class="content-table__col detail-item__title">
                            자녀정보
                        </div>
                        <div
                            class="content-table__col detail-item__content">
                            {{ reservation.childInfo }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item-purpose">
                        <div class="content-table__col detail-item-purpose__title">
                            방문목적
                        </div>
                        <div class="content-table__col detail-item-purpose__content">
                            {{ reservation.visitPurpose }}
                        </div>
                    </div>
                </div>
                <div class="submit-btn">
                    <button @click="handleCancel" v-if="reservation.status === 'WAITING'">예약 취소하기</button>
                    <button @click="handleBack" class="white">이전으로</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import { store } from "@/store";
import api from "@/api";

export default {
    name: "ReservationHistoryDetail",
    components: { GlobalHeader },
    data: () => ({
        store,
        reservation: []
    }),
    methods: {
        handleCancel() {
            this.$router.push({ path: `/schools/${store.school.id}/visit/history/${this.$route.params.id}/cancel` });
        },
        getStatusMessage(reservedStatus) {
            switch(reservedStatus) {
                case "WAITING": return "대기";
                case "ACCEPTED": return "승인";
                case "DENIED": return "반려";
                case "CANCELED": return "취소";
                default: return "";
            }
        },
        handleBack() {
            this.$router.replace({ path: `/schools/${store.school.id}/visit/history` });
        },
        async getReservation(id) {
            let params = {
                user_type: store.auth.type,
                token: store.auth.token,
            }
            this.reservation = await api.getReservation(params, id);
        }
    },
    mounted() {
        // 학교정보 없으면 초기화면으로 보냄
        if(!store.school.id) {
            this.$router.replace({ path: `/schools/${this.$route.params.school}/visit` });
        }

        this.getReservation(this.$route.params.id);
    },
};
</script>


<style scoped lang="scss">

</style>